module.exports = __webpack_public_path__ + "static/media/car-wash.dbb8cc63.svg";